import BukalapakFullIcon from 'assets/img/bukalapak-icon.png';
import AkulakuFullIcon from 'assets/img/akulaku-icon.png';
import BlibliFullIcon from 'assets/img/blibli-icon.png';
import LazadaFullIcon from 'assets/img/lazada-icon.png';
import ShopeeFullIcon from 'assets/img/shopee-icon.png';
import TokopediaFullIcon from 'assets/img/tokopedia-icon.png';
import ZaloraFullIcon from 'assets/img/zalora.png';
import ZilingoFullIcon from 'assets/img/zilingo.png';
import TadaFullIcon from 'assets/img/tada-full.png';
import DealPosFullIcon from 'assets/img/dealpos-full.png';
import EvermosFullIcon from 'assets/img/evermos-icon.png';
import FacebookFullIcon from 'assets/img/new-facebook.svg';
import JubelioPosFullIcon from 'assets/img/jubeliopos-full.png';
import ShopifyFullIcon from 'assets/img/shopify-icon.png';
import TiktokFullIcon from 'assets/img/tokopedia_shop-icon.png';
import WoocommerceFullIcon from 'assets/img/woocommerce-full.png';
import ShoplineIcon from 'assets/img/shopline.png';
import PlugoFullIcon from 'assets/img/plugo-full.png';
import JubelioIcon from 'assets/img/jubelio-icon.png';
import JubelioStoreIco from 'assets/img/jubelio-store-icon.svg';
import TocoIcon from 'assets/img/toco-logo-yellow.png';
import { ChannelDetail } from 'interfaces/Channels';

interface Channels {
  [key: string] : number;
}

export const CHANNELS: Channels = {
  SHOPEE: 64,
  TOKOPEDIA: 128,
  BUKALAPAK: 2,
  LAZADA: 4,
  BLIBLI: 32,
  TOCO: 131085,
  ZALORA: 8,
  ZILINGO: 2048,
  AKULAKU: 65536,
  TADA: 131077,
  JD: 4096,
  EVERMOS: 131078,
  FACEBOOK: 16386,
  TIKTOK: 131076,
  JUBELIO_POS: 524288,
  DEALPOS: 262144,
  WOOCOMMERCE: 131072,
  SHOPIFY: 1048576,
  SHOPLINE: 131079,
  ELEVENIA: 16,
  BLANJA: 512,
  QOO10: 1024,
  LYKE: 8192,
  LINE: 16384,
  INSTAGRAM: 16385,
  PRESTASHOP: 131073,
  MAGENTO: 131074,
  RALALI: 131075,
  JUBELIO_STORE: 524289,
  PLUGO: 131084,
  INTERNAL: 1
};

export const CHANNELNAMES = {
  INTERNAL: CHANNELS.INTERNAL,
  BUKALAPAK: CHANNELS.BUKALAPAK,
  LAZADA: CHANNELS.LAZADA,
  ZALORA: CHANNELS.ZALORA,
  ELEVENIA: CHANNELS.ELEVENIA,
  BLIBLI: CHANNELS.BLIBLI,
  SHOPEE: CHANNELS.SHOPEE,
  TOKOPEDIA: CHANNELS.TOKOPEDIA,
  MATAHARIMALL: CHANNELS.MATAHARIMALL,
  QOO10: CHANNELS.QOO10,
  ZILINGO: CHANNELS.ZILINGO,
  JD: CHANNELS.JD,
  OLX: CHANNELS.OLX,
  SOCIAL_MEDIA: CHANNELS.SOCIAL_MEDIA,
  FACEBOOK: CHANNELS.FACEBOOK,
  INSTAGRAM: CHANNELS.INSTAGRAM,
  WEBSTORE: CHANNELS.WEBSTORE,
  MAGENTO: CHANNELS.MAGENTO,
  DEALPOS: CHANNELS.DEALPOS,
  JUBELIO_POS: CHANNELS.JUBELIO_POS,
  HAPPYFRESH: CHANNELS.HAPPYFRESH,
  SHOPIFY: CHANNELS.SHOPIFY,
  AKULAKU: CHANNELS.AKULAKU,
  ['SHOP | TOKOPEDIA']:  CHANNELS.TIKTOK,
  TADA: CHANNELS.TADA,
  BLANJA: CHANNELS.BLANJA,
  JAKMALL: CHANNELS.JAKMALL,
  EVERMOS: CHANNELS.EVERMOS,
  SHOPLINE: CHANNELS.SHOPLINE,
  RENOS: CHANNELS.RENOS,
  JUBELIO_PAGE: CHANNELS.JUBELIO_PAGE,
  GRAAS_ANALYTIC: CHANNELS.GRAAS_ANALYTIC,
  ALADINMALL: CHANNELS.ALADINMALL,
  LAZADA_CHOICE: CHANNELS.LAZADA_CHOICE,
  JUBELIO_STORE: CHANNELS.JUBELIO_STORE,
  PLUGO: CHANNELS.PLUGO,
};

const channelDetail: ChannelDetail = {
  [CHANNELS.BUKALAPAK]: {
    channelName: 'Bukalapak',
    channelId: CHANNELS.BUKALAPAK,
    channelLogo: BukalapakFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-bukalapak-ke-jubelio'
  },
  [CHANNELS.LAZADA]: {
    channelName: 'Lazada',
    channelId: CHANNELS.LAZADA,
    channelLogo: LazadaFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-lazada-ke-jubelio-omnichannel'
  },
  [CHANNELS.ZALORA]: {
    channelName: 'Zalora',
    channelId: CHANNELS.ZALORA,
    channelLogo: ZaloraFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-zalora-ke-jubelio'
  },
  [CHANNELS.BLIBLI]: {
    channelName: 'Blibli',
    channelId: CHANNELS.BLIBLI,
    channelLogo: BlibliFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-blibli-ke-jubelio'
  },
  [CHANNELS.SHOPEE]: {
    channelName: 'Shopee',
    channelId: CHANNELS.SHOPEE,
    channelLogo: ShopeeFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-shopee-ke-jubelio'
  },
  [CHANNELS.TOKOPEDIA]: {
    channelName: 'Tokopedia',
    channelId: CHANNELS.TOKOPEDIA,
    channelLogo: TokopediaFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-tokopedia-ke-jubelio'
  },
  [CHANNELS.ZILINGO]: {
    channelName: 'Zilingo',
    channelId: CHANNELS.ZILINGO,
    channelLogo: ZilingoFullIcon,
    eduLink: '#' // not available
  },
  [CHANNELS.FACEBOOK]: {
    channelName: 'Facebook',
    channelId: CHANNELS.FACEBOOK,
    channelLogo: FacebookFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-social-commerce?menu=integrasi-facebook-shop-ke-jubelio' 
  },
  [CHANNELS.WOOCOMMERCE]: {
    channelName: 'Woocommerce',
    channelId: CHANNELS.WOOCOMMERCE,
    channelLogo: WoocommerceFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-webstore?menu=integrasi-woocommerce-dengan-jubelio-omnichannel' 
  },
  [CHANNELS.DEALPOS]: {
    channelName: 'Dealpos',
    channelId: CHANNELS.DEALPOS,
    channelLogo: DealPosFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-pos?menu=integrasi-dealpos-ke-jubelio-omnichannel'
  },
  [CHANNELS.JUBELIO_POS]: {
    channelName: 'Jubelio POS',
    channelId: CHANNELS.JUBELIO_POS,
    channelLogo: JubelioPosFullIcon,
    eduLink: '#' // not available
  },
  [CHANNELS.SHOPIFY]: {
    channelName: 'Shopify',
    channelId: CHANNELS.SHOPIFY,
    channelLogo: ShopifyFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-webstore?menu=integrasi-shopify-ke-jubelio-omnichannel' 
  },
  [CHANNELS.AKULAKU]: {
    channelName: 'Akulaku',
    channelId: CHANNELS.AKULAKU,
    channelLogo: AkulakuFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-marketplace?menu=integrasi-akulaku-ke-jubelio' 
  },
  [CHANNELS.TIKTOK]: {
    channelName: 'Shop | Tokopedia',
    channelId: CHANNELS.TIKTOK,
    channelLogo: TiktokFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-social-commerce?menu=integrasi-shop--tokopedia-ke-jubelio' 
  },
  [CHANNELS.TADA]: {
    channelName: 'Tada',
    channelId: CHANNELS.TADA,
    channelLogo: TadaFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-social-commerce?menu=integrasi-tada-ke-jubelio' 
  },
  [CHANNELS.EVERMOS]: {
    channelName: 'Evermos',
    channelId: CHANNELS.EVERMOS,
    channelLogo: EvermosFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-social-commerce?menu=integrasi-evermos-ke-jubelio' 
  },
  [CHANNELS.SHOPLINE]: {
    channelName: 'Shopline',
    channelId: CHANNELS.SHOPLINE,
    channelLogo: ShoplineIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-social-commerce?menu=integrasi-shopline-ke-jubelio' 
  },
  [CHANNELS.PLUGO]: {
    channelName: 'Plugo',
    channelId: CHANNELS.PLUGO,
    channelLogo: PlugoFullIcon,
    eduLink: 'https://education.jubelio.com/classes/course/integrasi-webstore?menu=integrasi-plugo-ke-jubelio-omnichannel' 
  },
  [CHANNELS.INTERNAL]: {
    channelName: 'Internal Jubelio',
    channelId: CHANNELS.INTERNAL,
    channelLogo: JubelioIcon,
    eduLink: '#' 
  },
  [CHANNELS.JUBELIO_STORE]: {
    channelName: 'Jubelio Store',
    channelId: CHANNELS.JUBELIO_STORE,
    channelLogo: JubelioStoreIco,
    eduLink: '#'
  },
  [CHANNELS.TOCO]: {
    channelName: 'Toco',
    channelId: CHANNELS.TOCO,
    channelLogo: TocoIcon,
    eduLink: '#'
  },
};

const SUPPORTED_IMPORT_FROM_MP = [
  CHANNELS.SHOPEE, CHANNELS.LAZADA, CHANNELS.TOKOPEDIA, CHANNELS.TIKTOK
]

const dateFormatRegex = /^\d{2} [A-Z][a-z]{2} \d{4}$/; // 'dd mmm yyyy' format regex
const timeFormatRegex = /^([01]\d|2[0-3]):[0-5]\d$/;

export const FSID_LIST = [
  13024, 14264, 14333, 14334, 14335, 14060, 14246, 14330, 14332, 14331, 18157, 18158, 18159, 18160, 18161,
];

export { channelDetail, CHANNELS as channels, dateFormatRegex, timeFormatRegex, SUPPORTED_IMPORT_FROM_MP };
// export default channelLogo;
